import { IRegionSpecialPromo } from '../types/specialPromos';

export const PIK_PROMO_REGIONS = [1, 4593];
export const PIK_PROMO: IRegionSpecialPromo = {
  developerId: 9,
  regions: PIK_PROMO_REGIONS,
  filterLabel: 'Показать ЖК от ПИК',
};
